import { baseQueryParams, Filter, slugify } from 'src/utils';

type GetProjectOverviewUrlParamsProps = {
  city?: string;
  region?: string;
  cityFilterOptions?: string[];
  regionFilterOptions?: Filter[];
  page?: number;
};

export const getProjectOverviewUrlParams = ({
  city,
  cityFilterOptions,
  region,
  regionFilterOptions,
  page,
}: GetProjectOverviewUrlParamsProps): Partial<Record<keyof typeof baseQueryParams, string>> => {
  const selectedCity =
    city && cityFilterOptions
      ? cityFilterOptions.find((cityOption) => slugify(cityOption) === slugify(city))
      : undefined;

  const selectedRegion =
    region && regionFilterOptions
      ? regionFilterOptions.find((regionOption) => regionOption.id === region)
      : undefined;

  return {
    [baseQueryParams.region]: selectedRegion ? slugify(selectedRegion.name) : '',
    [baseQueryParams.city]: selectedCity ? slugify(selectedCity) : '',
    [baseQueryParams.page]: page,
  };
};
